"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_picker_1 = tslib_1.__importDefault(require("rc-picker"));
var config_provider_1 = require("../../../config-provider");
var _1 = require(".");
var SizeContext_1 = tslib_1.__importDefault(require("../../../config-provider/SizeContext"));
var NormalCalendar_1 = require("../../../Icons/NormalCalendar");
var NormalTimeCircle_1 = require("../../../Icons/NormalTimeCircle");
var PromptCloseCircleFill_1 = require("../../../Icons/PromptCloseCircleFill");
var zh_CN_1 = tslib_1.__importDefault(require("../locale/zh_CN"));
var util_1 = require("../util");
var utils_1 = require("./utils");
function generatePicker(generateConfig) {
    function getPicker(picker, displayName) {
        var Picker = /** @class */ (function (_super) {
            tslib_1.__extends(Picker, _super);
            function Picker(props) {
                var _this = _super.call(this, props) || this;
                _this.pickerRef = React.createRef();
                _this.focus = function () {
                    if (_this.pickerRef.current) {
                        _this.pickerRef.current.focus();
                    }
                };
                _this.blur = function () {
                    if (_this.pickerRef.current) {
                        _this.pickerRef.current.blur();
                    }
                };
                _this.renderPicker = function () {
                    var _a = _this.context, getPrefixCls = _a.getPrefixCls, direction = _a.direction, getPopupContainer = _a.getPopupContainer;
                    var _b = _this.props, customizePrefixCls = _b.prefixCls, customizeGetPopupContainer = _b.getPopupContainer, className = _b.className, customizeSize = _b.size, _c = _b.bordered, bordered = _c === void 0 ? true : _c, placeholder = _b.placeholder, restProps = tslib_1.__rest(_b, ["prefixCls", "getPopupContainer", "className", "size", "bordered", "placeholder"]);
                    var _d = _this.props, format = _d.format, showTime = _d.showTime;
                    var prefixCls = getPrefixCls('picker', customizePrefixCls);
                    var additionalProps = {
                        showToday: true,
                    };
                    var additionalOverrideProps = {};
                    if (picker) {
                        additionalOverrideProps.picker = picker;
                    }
                    var mergedPicker = picker || _this.props.picker;
                    additionalOverrideProps = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, additionalOverrideProps), (showTime ? (0, _1.getTimeProps)(tslib_1.__assign({ format: format, picker: mergedPicker }, showTime)) : {})), (mergedPicker === 'time'
                        ? (0, _1.getTimeProps)(tslib_1.__assign(tslib_1.__assign({ format: format }, _this.props), { picker: mergedPicker }))
                        : {}));
                    return (React.createElement(SizeContext_1.default.Consumer, null, function (size) {
                        var _a;
                        var mergedSize = customizeSize || size;
                        return (React.createElement(rc_picker_1.default, tslib_1.__assign({ ref: _this.pickerRef, placeholder: (0, util_1.getPlaceholder)(mergedPicker, zh_CN_1.default, placeholder), suffixIcon: mergedPicker === 'time' ? React.createElement(NormalTimeCircle_1.NormalTimeCircle, null) : React.createElement(NormalCalendar_1.NormalCalendar, null), clearIcon: React.createElement(PromptCloseCircleFill_1.PromptCloseCircleFill, null), allowClear: true, transitionName: "slide-up" }, additionalProps, restProps, additionalOverrideProps, { locale: zh_CN_1.default.lang, className: (0, classnames_1.default)((_a = {},
                                _a["".concat(prefixCls, "-").concat(mergedSize)] = mergedSize,
                                _a["".concat(prefixCls, "-borderless")] = !bordered,
                                _a), className), prefixCls: prefixCls, getPopupContainer: customizeGetPopupContainer || getPopupContainer, generateConfig: generateConfig, prevIcon: React.createElement("span", { className: "".concat(prefixCls, "-prev-icon") }), nextIcon: React.createElement("span", { className: "".concat(prefixCls, "-next-icon") }), superPrevIcon: React.createElement("span", { className: "".concat(prefixCls, "-super-prev-icon") }), superNextIcon: React.createElement("span", { className: "".concat(prefixCls, "-super-next-icon") }), components: _1.Components, direction: direction, onOpenChange: (0, utils_1.openChangeHandler)(prefixCls, _this.props.onOpenChange) })));
                    }));
                };
                return _this;
            }
            Picker.prototype.render = function () {
                return React.createElement(React.Fragment, null, this.renderPicker());
            };
            Picker.contextType = config_provider_1.ConfigContext;
            return Picker;
        }(React.Component));
        if (displayName) {
            Picker.displayName = displayName;
        }
        return Picker;
    }
    var DatePicker = getPicker();
    var WeekPicker = getPicker('week', 'WeekPicker');
    var MonthPicker = getPicker('month', 'MonthPicker');
    var YearPicker = getPicker('year', 'YearPicker');
    var TimePicker = getPicker('time', 'TimePicker');
    var QuarterPicker = getPicker('quarter', 'QuarterPicker');
    return {
        DatePicker: DatePicker,
        WeekPicker: WeekPicker,
        MonthPicker: MonthPicker,
        YearPicker: YearPicker,
        TimePicker: TimePicker,
        QuarterPicker: QuarterPicker,
    };
}
exports.default = generatePicker;
//# sourceMappingURL=generateSinglePicker.js.map